<template>
  <path
    d="M12 17.2702L16.15 19.7802C16.91 20.2402 17.8399 19.5602 17.6399 18.7002L16.54 13.9802L20.2099 10.8002C20.8799 10.2202 20.5199 9.12019 19.6399 9.05019L14.81 8.64019L12.92 4.18019C12.58 3.37019 11.42 3.37019 11.08 4.18019L9.18995 8.63019L4.35995 9.04019C3.47995 9.11019 3.11995 10.2102 3.78995 10.7902L7.45995 13.9702L6.35995 18.6902C6.15995 19.5502 7.08995 20.2302 7.84995 19.7702L12 17.2702Z"
  />
</template>
